import { PlusIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "@material-tailwind/react";
import React from "react";
import { LuSendHorizonal } from "react-icons/lu";
// import { getId } from "../../api";
import { useNavigate } from "react-router-dom";
import { delete_user_data_from_client_side } from "../../utils/common";
import { getId } from "../../api/axiosApi";

interface TextAreaWithButtonProps {
    prompt: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onGenerateResponse: () => void;
    isLoading: boolean;
}
export const TextAreaWithButton = ({ prompt, onChange, onGenerateResponse, isLoading }: TextAreaWithButtonProps) => {
    const navigate = useNavigate();
    const clickToCreateNewThought = async () => {
        try {
            const idResponse = await getId();
            // if (idResponse.status === 401 || idResponse.status === 422) {
            //     delete_user_data_from_client_side()
            //     navigate("/user_login");
            // }
            // if (!idResponse.ok) {
            //     throw new Error(`Failed to fetch ID: ${idResponse.status}`);
            // }
            const id = await idResponse.data;
            console.log("epoch time: ", id.Id);
            navigate(`/interaction/${id.Id}`, { state: { from: "new" } });
            location.reload();
        } catch (error) {
            console.error("Failed to fetch ID and navigate", error);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            if (!isLoading && prompt.trim().length > 0) {
                onGenerateResponse();
            }
        }
    };

    return (
        <div className="fixed bottom-0  md:pt-0 w-[calc(100%-6rem)] juice:w-full  min-w-80  bg-neutral-100 ">
            <div className="mt-3 flex items-center justify-center mb-3">
                <textarea
                    className="rounded-xl resize-none border p-2 w-8/12 shadow-2xl"
                    id="promptInput"
                    placeholder="Let's discuss"
                    value={prompt}
                    onChange={onChange}
                    onKeyDown={handleKeyDown}
                    autoFocus
                />

                <button onClick={onGenerateResponse} disabled={!prompt.trim() || isLoading} className="text-green-800 ml-2  p-2 ">
                    <LuSendHorizonal />
                </button>
                <Tooltip content="New Interaction" placement="right" className="text-white bg-green-800 font-bold p-2">
                    <div onClick={clickToCreateNewThought} className="arrowForMore hover:cursor-pointer  shadow-md">
                        <PlusIcon className="arrow-icon text-green-800 h-8 w-8" />
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};
